'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var FlightAnalysisGridService = function FlightAnalysisGridService($rootScope, flightCabinGridTransformerFactory, flightClassGridTransformerFactory, flightSegmentGridTransformerFactory, flightServiceClassGridTransformerFactory, flightSummaryDataTransformerService, reoptimizationService, mergeScenarioDataService) {
  function update(rowsInGrid, newRows, gridId, TransformerFactory, isTransformerService) {
    var transformedRows;
    if (isTransformerService) {
      transformedRows = TransformerFactory.transform(newRows);
    } else {
      transformedRows = new TransformerFactory().transform({
        domain: newRows
      });
    }
    var dirtyProductionRows = mergeScenarioDataService.mergePreviewScenario(rowsInGrid, transformedRows, gridId);
    if (!_.isEmpty(dirtyProductionRows)) {
      $rootScope.$broadcast('grid:loadedDataChanged:' + gridId, dirtyProductionRows);
    }
    return rowsInGrid;
  }
  function filterRowsByFlight(rows, reoptPreviewData) {
    if (reoptPreviewData && reoptPreviewData.ndReopt && reoptPreviewData.ndReopt.flightId) {
      return _.filter(rows, {
        flightId: reoptPreviewData.ndReopt.flightId
      });
    } else {
      return rows;
    }
  }
  function filterByFlight(jqxGridSettings, previewingRow) {
    if (jqxGridSettings.source) {
      return filterRowsByFlight(jqxGridSettings.source.loadedData, previewingRow);
    } else {
      return [];
    }
  }
  function compareFlightCabinGridRows(rowsInGrid, newRows, gridId) {
    return update(rowsInGrid, newRows, gridId, flightCabinGridTransformerFactory);
  }
  function compareFlightClassGridRows(rowsInGrid, newRows, gridId) {
    return update(rowsInGrid, newRows, gridId, flightClassGridTransformerFactory);
  }
  function compareFlightSegmentGridRows(rowsInGrid, newRows, gridId) {
    return update(rowsInGrid, newRows, gridId, flightSegmentGridTransformerFactory);
  }
  function compareFlightSummaryGridRows(rowsInGrid, newRows, gridId) {
    return update(rowsInGrid, newRows, gridId, flightSummaryDataTransformerService, true);
  }
  function updateReoptFlightCabins(gridId, jqxGridSettings, previewingRow) {
    return reoptimizationService.getLegCabins(previewingRow, gridId).then(function (rowsFromServer) {
      if (rowsFromServer.results.length > 0) {
        compareFlightCabinGridRows(filterByFlight(jqxGridSettings, previewingRow), rowsFromServer, gridId);
      } else {
        toastr.warning('Preview scenario is not available, please submit new preview request.');
      }
    });
  }
  function updateReoptFlightClasses(gridId, jqxGridSettings, previewingRow) {
    return reoptimizationService.getLegClasses(previewingRow, gridId).then(function (rowsFromServer) {
      if (rowsFromServer.resources.length > 0) {
        compareFlightClassGridRows(filterByFlight(jqxGridSettings, previewingRow), rowsFromServer, gridId);
      } else {
        toastr.warning('Preview scenario is not available, please submit new preview request.');
      }
    });
  }
  function updateReoptFlightSegments(gridId, jqxGridSettings, previewingRow) {
    return reoptimizationService.getSegmentClasses(previewingRow, gridId).then(function (rowsFromServer) {
      if (rowsFromServer.segmentClasses.length > 0) {
        compareFlightSegmentGridRows(filterByFlight(jqxGridSettings, previewingRow), rowsFromServer, gridId);
      } else {
        toastr.warning('Preview scenario is not available, please submit new preview request.');
      }
    });
  }
  function updateReoptFlightSummary(gridId, jqxGridSettings, previewingRow, scenarioName) {
    return reoptimizationService.getFlightSummary(previewingRow, scenarioName).then(function (rowsFromServer) {
      if (rowsFromServer.resources.length > 0) {
        compareFlightSummaryGridRows(filterByFlight(jqxGridSettings, previewingRow), rowsFromServer, gridId);
      } else {
        toastr.warning('Preview scenario is not available, please submit new preview request.');
      }
    });
  }
  function updateReoptPreviewRows(gridId, jqxGridSettings, previewingRow, scenarioName) {
    switch (gridId) {
      case 'flight-summary':
        return updateReoptFlightSummary(gridId, jqxGridSettings, previewingRow, scenarioName);
      case 'cabin-flight-analysis':
      case 'overbooking-management':
        return updateReoptFlightCabins(gridId, jqxGridSettings, previewingRow);
      case 'class-flight-analysis':
      case 'inventory-management':
        return updateReoptFlightClasses(gridId, jqxGridSettings, previewingRow);
      case 'segment-flight-analysis':
        return updateReoptFlightSegments(gridId, jqxGridSettings, previewingRow);
    }
  }
  function resetPDDGrid() {
    $rootScope.$broadcast('grid:clearSelection');
  }
  return {
    updateReoptPreviewRows: updateReoptPreviewRows,
    resetPDDGrid: resetPDDGrid
  };
};
FlightAnalysisGridService.$inject = ['$rootScope', 'FlightCabinGridTransformerFactory', 'FlightClassGridTransformerFactory', 'FlightSegmentGridTransformerFactory', 'FlightServiceClassGridTransformerFactory', 'FlightSummaryDataTransformerService', 'ReoptimizationService', 'MergeScenarioDataService'];
module.exports = FlightAnalysisGridService;